/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Fit_Single_Line_LabelInputs */

const en_style_guide_manager_fit_single_line_label = /** @type {(inputs: Style_Guide_Manager_Fit_Single_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fit Single Line`)
};

const fr_style_guide_manager_fit_single_line_label = /** @type {(inputs: Style_Guide_Manager_Fit_Single_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapter a une seule ligne`)
};

const de_style_guide_manager_fit_single_line_label = /** @type {(inputs: Style_Guide_Manager_Fit_Single_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passt für Einzelleitungen`)
};

const it_style_guide_manager_fit_single_line_label = /** @type {(inputs: Style_Guide_Manager_Fit_Single_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adatta la linea singola`)
};

const ru_style_guide_manager_fit_single_line_label = /** @type {(inputs: Style_Guide_Manager_Fit_Single_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подгонка по одной линии`)
};

const es_style_guide_manager_fit_single_line_label = /** @type {(inputs: Style_Guide_Manager_Fit_Single_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste de línea única`)
};

const zh_cn2_style_guide_manager_fit_single_line_label = /** @type {(inputs: Style_Guide_Manager_Fit_Single_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合单线`)
};

const ja_style_guide_manager_fit_single_line_label = /** @type {(inputs: Style_Guide_Manager_Fit_Single_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単一行に合わせる`)
};

const hi_style_guide_manager_fit_single_line_label = /** @type {(inputs: Style_Guide_Manager_Fit_Single_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिंगल लाइन फिट करें`)
};

const pt_pt2_style_guide_manager_fit_single_line_label = /** @type {(inputs: Style_Guide_Manager_Fit_Single_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste de linha única`)
};

/**
* | output |
* | --- |
* | "Fit Single Line" |
*
* @param {Style_Guide_Manager_Fit_Single_Line_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_fit_single_line_label = /** @type {((inputs?: Style_Guide_Manager_Fit_Single_Line_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Fit_Single_Line_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_fit_single_line_label(inputs)
	if (locale === "de") return de_style_guide_manager_fit_single_line_label(inputs)
	if (locale === "it") return it_style_guide_manager_fit_single_line_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_fit_single_line_label(inputs)
	if (locale === "es") return es_style_guide_manager_fit_single_line_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_fit_single_line_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_fit_single_line_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_fit_single_line_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_fit_single_line_label(inputs)
	return en_style_guide_manager_fit_single_line_label(inputs)
});